import { UnbezahlteUeberstunden } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/UnbezahlteUeberstunden';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { calculateHoursSum } from '@/domain/mitarbeiter/features/anlageassistent/utils/calculateHoursSum';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function StundenMonat() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const [summeStunden, setSummeStunden] = useState('');

  const handleSummenCalculation = () => {
    const monatsstunden =
      form.state.values.bezahlung.arbeitszeitkonto.gehaltsempfaenger
        ?.monatsstunden;
    const ueberstunden =
      form.state.values.bezahlung.arbeitszeitkonto.gehaltsempfaenger
        ?.unbezahlteUeberstundenMonat;
    const values: string[] = [];
    if (monatsstunden) {
      values.push(monatsstunden);
    } else {
      setSummeStunden('');
      return;
    }
    if (ueberstunden) {
      values.push(ueberstunden);
    }

    if (values.length > 0) {
      setSummeStunden(calculateHoursSum(values));
    } else {
      setSummeStunden('');
    }
  };

  useEffect(() => {
    handleSummenCalculation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <span className="text-neutrals-800 text-sm font-normal leading-5">
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.monatsstunden.description',
        )}
      </span>
      <div className="flex flex-col gap-4">
        <div className="flex gap-4 items-start">
          <form.AppField
            name="bezahlung.arbeitszeitkonto.gehaltsempfaenger.monatsstunden"
            listeners={{
              onBlur: () => {
                handleSummenCalculation();
              },
            }}>
            {(field) => (
              <field.HoursInput
                label={t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.monatsstunden.label',
                )}
                isRequired
                suffix="Std."
                placeholder="hh:mm"
              />
            )}
          </form.AppField>
          <UnbezahlteUeberstunden onBlur={handleSummenCalculation} />
        </div>
        {summeStunden && (
          <span className="text-neutrals-800 text-xs font-normal leading-4">
            {t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.monatsstunden.info',
              {
                stunden: summeStunden,
              },
            )}
          </span>
        )}
      </div>
    </>
  );
}
